export const MAX_CONFIRMATION = 12;
